/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Audit_Title5Inputs */

const en_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fixed-price code audit`)
};

const ar_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تدقيق الشيفرة بسعر ثابت`)
};

const bn_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিক্সড-প্রাইস কোড অডিট`)
};

const de_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code-Audit zum Festpreis`)
};

const es_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditoría de código a precio fijo`)
};

const fr_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit de code au forfait`)
};

const pt_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditoria de código a preço fixo`)
};

const zh_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`固定价格代码审计`)
};

const tr_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabit fiyatlı kod denetimi`)
};

const ru_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аудит кода за фикс-прайс`)
};

const pl_svc_ai_app_rescue_audit_title5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audyt kodu za stałą cenę`)
};

/**
* | output |
* | --- |
* | "Fixed-price code audit" |
*
* @param {Svc_Ai_App_Rescue_Audit_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_audit_title5 = /** @type {((inputs?: Svc_Ai_App_Rescue_Audit_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Audit_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_audit_title5(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_audit_title5(inputs)
	return en_svc_ai_app_rescue_audit_title5(inputs)
});
export { svc_ai_app_rescue_audit_title5 as "svc_ai-app-rescue_AUDIT_title" }